import React from "react";

const AcceptableUsePolicy = () => {
  return (
    <div className="ct_policy_page">
      <div className="ct_policy_container">
        <div className="ct_policy_header">
          <div style={{ marginBottom: "20px" }}>
            <img src="/img/Logo_blue_new.png" alt="First Mate Logo" style={{ height: "70px", objectFit: "contain" }} />
          </div>
          <h1 className="ct_policy_title">ACCEPTABLE USE POLICY</h1>
          <p className="ct_policy_meta">
            Schedule B · Version 1.0
          </p>
          <div style={{ fontSize: "13px", color: "#64748b", marginTop: "5px" }}>
            <strong>Issued By:</strong> First Mate Pty Ltd, Queensland, Australia
          </div>
        </div>
        <div className="ct_policy_content">
          <p>
            This Acceptable Use Policy ("Policy") forms part of the Servicehub Software Services Agreement between First Mate Pty Ltd ("First Mate") and the Provider.
          </p>
          <p>
            The purpose of this Policy is to ensure the secure, lawful, professional and responsible use of the Servicehub platform by all users.
          </p>

          <h3>1. PURPOSE</h3>
          <p>
            Servicehub is designed to assist marine service providers, maintenance businesses, shipyards, marinas, brokers, fleet operators and related organisations with managing maintenance, service delivery, customer communications, asset records and digital service histories.
          </p>
          <p>
            Users must only use Servicehub for legitimate business purposes and in accordance with this Policy.
          </p>

          <h3>2. COMPLIANCE WITH LAWS</h3>
          <p>Providers must comply with all applicable laws and regulations when using Servicehub, including but not limited to:</p>
          <ul>
            <li>Privacy and data protection laws;</li>
            <li>Consumer protection laws;</li>
            <li>Employment laws;</li>
            <li>Intellectual property laws;</li>
            <li>Maritime regulations;</li>
            <li>Workplace health and safety requirements;</li>
            <li>Anti-spam legislation.</li>
          </ul>
          <p>Providers are solely responsible for ensuring their use of Servicehub complies with all applicable legal obligations.</p>
          <p>
            Without limiting the above, Providers must specifically comply with the Privacy Act 1988 (Cth), the Australian Privacy Principles (APPs), and the Notifiable Data Breaches scheme under Part IIIC of the Privacy Act 1988 (Cth). Where a Provider becomes aware of an eligible data breach involving personal information stored on or accessed through the Platform, the Provider must promptly notify First Mate with sufficient detail to enable First Mate to meet its own obligations under the Notifiable Data Breaches scheme.
          </p>

          <h3>3. PROFESSIONAL CONDUCT</h3>
          <p>Users must conduct themselves in a professional and respectful manner when using the Platform.</p>
          <p>Users must not:</p>
          <ul>
            <li>Harass, threaten or intimidate others;</li>
            <li>Upload offensive, abusive or discriminatory material;</li>
            <li>Use inappropriate language;</li>
            <li>Misrepresent themselves or their business;</li>
            <li>Damage the reputation of other users or First Mate.</li>
          </ul>

          <h3>4. PROHIBITED ACTIVITIES</h3>
          <p>Providers must not use Servicehub to:</p>
          <ul>
            <li>Commit unlawful acts;</li>
            <li>Facilitate fraud or deception;</li>
            <li>Submit false information;</li>
            <li>Circumvent legal obligations;</li>
            <li>Create misleading service records;</li>
            <li>Falsify maintenance histories;</li>
            <li>Alter records for deceptive purposes;</li>
            <li>Misrepresent warranty status;</li>
            <li>Mislead customers or third parties.</li>
          </ul>
          <p>Any attempt to use Servicehub for fraudulent or deceptive activities may result in immediate account suspension or termination.</p>

          <h3>5. SERVICE RECORD INTEGRITY</h3>
          <p>Servicehub relies upon accurate maintenance and service records.</p>
          <p>Providers must ensure that:</p>
          <ul>
            <li>Service records are truthful;</li>
            <li>Maintenance activities are accurately documented;</li>
            <li>Dates are correct;</li>
            <li>Warranty information is accurate;</li>
            <li>Technician details are accurate;</li>
            <li>Customer information is current.</li>
          </ul>
          <p>Providers must not knowingly create inaccurate service histories.</p>
          <p>
            The Provider remains solely responsible for the content and accuracy of all records entered into the Platform. First Mate will use reasonable endeavours to maintain the Platform in a manner that preserves the integrity of records stored by Providers, but does not warrant that the Platform will be free from errors, interruptions or data loss at all times.
          </p>

          <h3>6. CUSTOMER DATA</h3>
          <p>Providers must only upload customer information where they have lawful authority to do so.</p>
          <p>Providers must not:</p>
          <ul>
            <li>Collect personal information without the individual’s knowledge or consent, unless otherwise expressly permitted by applicable privacy law;</li>
            <li>Upload personal information unnecessarily;</li>
            <li>Share customer information improperly;</li>
            <li>Use customer data for unlawful marketing activities.</li>
          </ul>
          <p>Customer information should only be used for legitimate business purposes related to service delivery and customer management.</p>
          <p>
            Providers must not use information collected through the Platform for any secondary purpose (including marketing, resale, insurance assessments or use in legal proceedings) without the express consent of the relevant individual or as otherwise permitted by the Privacy Act 1988 (Cth) and the Australian Privacy Principles.
          </p>

          <h3>7. SECURITY REQUIREMENTS</h3>
          <p>Providers must take reasonable measures to protect access to Servicehub. This includes:</p>
          <ul>
            <li>Maintaining secure passwords;</li>
            <li>Using multi-factor authentication where available;</li>
            <li>Restricting access to authorised personnel;</li>
            <li>Removing access for former employees;</li>
            <li>Protecting devices used to access the Platform.</li>
          </ul>
          <p>Providers must notify First Mate promptly if they become aware of any security breach or unauthorised access.</p>

          <h3>8. MALICIOUS ACTIVITY</h3>
          <p>Users must not:</p>
          <ul>
            <li>Upload viruses;</li>
            <li>Upload malware;</li>
            <li>Upload ransomware;</li>
            <li>Attempt unauthorised access;</li>
            <li>Probe security vulnerabilities;</li>
            <li>Interfere with Platform operations;</li>
            <li>Conduct penetration testing without written permission;</li>
            <li>Disrupt other users.</li>
          </ul>
          <p>Any malicious activity may result in immediate suspension and referral to relevant authorities.</p>

          <h3>9. SYSTEM ABUSE</h3>
          <p>Users must not:</p>
          <ul>
            <li>Attempt to overload the Platform;</li>
            <li>Use automated tools to scrape data;</li>
            <li>Circumvent usage limits;</li>
            <li>Create multiple accounts to avoid subscription fees;</li>
            <li>Interfere with system performance;</li>
            <li>Reverse engineer any part of the Platform.</li>
          </ul>

          <h3>10. INTELLECTUAL PROPERTY</h3>
          <p>Users must respect the intellectual property rights of others. Providers must not upload or distribute content that:</p>
          <ul>
            <li>Infringes copyright;</li>
            <li>Infringes trademarks;</li>
            <li>Infringes patents;</li>
            <li>Violates confidentiality obligations.</li>
          </ul>
          <p>
            The Provider warrants that it has all necessary rights to any content uploaded to Servicehub and that such content does not infringe the intellectual property rights of any third party. The Provider indemnifies First Mate against all claims, losses, damages, costs (including legal costs on a solicitor-client basis) and expenses arising from or in connection with any breach of this warranty. First Mate warrants that the Servicehub platform, as made available to the Provider, does not infringe the intellectual property rights of any third party.
          </p>

          <h3>11. COMMUNICATIONS</h3>
          <p>Providers must ensure communications sent through Servicehub are accurate, professional, lawful, and relevant to the recipient.</p>
          <p>Users must not use Servicehub to distribute:</p>
          <ul>
            <li>Spam;</li>
            <li>Unsolicited marketing;</li>
            <li>Fraudulent communications;</li>
            <li>Misleading information.</li>
          </ul>

          <h3>12. INTEGRATION WITH FIRST MATE</h3>
          <p>Where Servicehub is connected to the First Mate application ecosystem, Providers must ensure that information shared with vessel owners is accurate, current, relevant, and lawfully disclosed.</p>
          <p>
            Providers acknowledge that end customers may rely upon information transferred through the Platform. First Mate acts in a purely technical and facilitative capacity in respect of all such transfers and does not review, verify, endorse or take responsibility for the accuracy, completeness or currency of any information transferred through the Platform. First Mate is not a party to any representation made by a Provider to any customer or third party. The Provider indemnifies First Mate against any third-party claims, losses or costs arising from inaccurate, incomplete or misleading information transferred through the Platform by or on behalf of the Provider.
          </p>

          <h3>13. MAINTENANCE REQUESTS AND WARRANTY CLAIMS</h3>
          <p>Providers must review all Maintenance Requests and Warranty Requests independently.</p>
          <p>Servicehub acts only as an information management platform and does not:</p>
          <ul>
            <li>Validate requests;</li>
            <li>Verify customer claims;</li>
            <li>Determine warranty eligibility;</li>
            <li>Approve maintenance works.</li>
          </ul>
          <p>
            Providers remain responsible for all decisions relating to customer requests. Providers must not rely on Servicehub for safety-critical decisions or for the purposes of complying with obligations under maritime safety legislation, including the Marine Safety (Domestic Commercial Vessel) National Law Act 2012 (Cth) or applicable state and territory maritime safety laws. Providers remain solely responsible for making independent professional judgements regarding vessel maintenance, vessel safety, and regulatory compliance.
          </p>

          <h3>14. AUDIT RIGHTS</h3>
          <p>First Mate reserves the right to investigate suspected breaches of this Policy. This may include reviewing account activity, reviewing uploaded content, requesting explanations regarding suspected misuse, and suspending accounts while investigations are conducted.</p>

          <h3>15. ENFORCEMENT</h3>
          <p>
            Where First Mate reasonably suspects a breach of this Policy, it will generally seek to resolve the matter by first issuing a written warning and allowing the Provider a reasonable opportunity to remedy the breach (being not less than 7 days, except where the breach is incapable of remedy). Where the breach is not remedied within the specified period, or where the breach constitutes a Serious Breach (as defined in this clause), First Mate may take such further action as it considers appropriate, including: issuing warnings, restricting functionality, suspending access, terminating accounts, removing content, and reporting unlawful conduct to authorities.
          </p>
          <p>
            For the purposes of this Policy, a Serious Breach means any of the following: (a) fraudulent, dishonest or deceptive conduct in connection with the Platform; (b) falsification or deliberate alteration of service records or maintenance histories; (c) a material breach of applicable law in connection with the Provider’s use of the Platform; (d) an insolvency event affecting the Provider; (e) conduct that poses a genuine risk to the safety of persons or vessels; or (f) a repeated breach of this Policy following a prior written warning. Where First Mate suspends or terminates an account pursuant to this clause, the affected Provider may request a review of that decision by contacting First Mate in writing within 14 days of receiving notice of the suspension or termination.
          </p>

          <h3>16. REPORTING BREACHES</h3>
          <p>
            Providers are encouraged to report suspected misuse of Servicehub to First Mate as soon as reasonably practicable. Reports may be submitted to: <a href="mailto:ahoy@firstmate.com.au">ahoy@firstmate.com.au</a>.
          </p>

          <h3>17. CHANGES TO THIS POLICY</h3>
          <p>First Mate may amend this Policy from time to time. Updated versions will be made available through the Servicehub platform and website.</p>
          <p>
            First Mate will provide Providers with not less than 14 days’ prior written notice (by email to the address registered with Servicehub or by in-platform notification) before any material amendment to this Policy takes effect. Non-material amendments (such as clarificatory changes that do not alter the substantive rights or obligations of the parties) may take effect upon publication. If a Provider does not accept a material amendment, the Provider may terminate its subscription without penalty by providing written notice to First Mate before the amendment’s effective date. Continued use of Servicehub after the effective date of any amendment constitutes the Provider’s acceptance of the revised Policy.
          </p>

          <h3>18. LIMITATION OF LIABILITY</h3>
          <p>
            Nothing in this Policy or the Agreement excludes, restricts or modifies any right or guarantee that cannot be excluded, restricted or modified under the Australian Consumer Law (Schedule 2 of the Competition and Consumer Act 2010 (Cth)) (ACL) or any other applicable law.
          </p>
          <p>
            To the maximum extent permitted by law, First Mate’s aggregate liability to the Provider for all claims arising under or in connection with this Policy or the Provider’s use of Servicehub (whether in contract, tort (including negligence), statute or otherwise) is limited to the total fees paid by the Provider to First Mate in the 12 months immediately preceding the event giving rise to the claim.
          </p>
          <p>
            To the maximum extent permitted by law, First Mate excludes all liability for: (a) indirect, consequential, special, incidental or punitive loss or damage; (b) loss of profit, revenue, data, business opportunity or goodwill; and (c) losses arising from the Provider’s reliance on information entered into the Platform by any other party.
          </p>
          <p>
            Where First Mate’s liability to a Provider cannot be fully excluded under the ACL and the relevant services are not ordinarily acquired for personal, domestic or household use, First Mate’s liability for a failure to comply with a statutory guarantee is limited, at First Mate’s election, to: (a) the resupply of the services; or (b) the payment of the cost of having the services supplied again, pursuant to section 64A of the ACL.
          </p>
          <p>
            The Provider acknowledges that the limitations of liability set out in this clause reflect a fair and reasonable allocation of risk having regard to the nature of the services and the fees payable under the Agreement.
          </p>

          <h3>19. THIRD-PARTY CONTENT AND INTERMEDIARY ROLE</h3>
          <p>
            Servicehub is a platform that facilitates the input, storage, management and transmission of information by and between Providers and other users. First Mate acts solely as a platform intermediary and does not generate, author, review, verify, validate or endorse any content uploaded by Providers or transmitted through the Platform.
          </p>
          <p>
            First Mate makes no representation or warranty, express or implied, as to the accuracy, completeness, currency, reliability, fitness for purpose or suitability of any content uploaded by Providers or accessible through third-party integrations connected to the Platform.
          </p>
          <p>
            Users should independently verify any information obtained through or displayed on the Platform before relying upon it, particularly where that information relates to vessel safety, regulatory compliance, warranty status or maintenance history.
          </p>
          <p>
            To the maximum extent permitted by law, First Mate disclaims all liability arising from any user’s reliance on information that originates from or has been inputted by a Provider or third party.
          </p>

          <h3>20. FORCE MAJEURE</h3>
          <p>
            First Mate will not be liable for any failure or delay in providing access to or functionality of Servicehub to the extent that such failure or delay is directly caused by circumstances beyond First Mate’s reasonable control, including acts of God, cyberattacks by third parties, telecommunications or internet infrastructure failures, government actions, natural disasters, pandemics, epidemics or power failures (each a Force Majeure Event).
          </p>
          <p>
            First Mate will use reasonable endeavours to restore Platform services as soon as practicable following a Force Majeure Event and will notify Providers of any material outage and the steps being taken to restore services.
          </p>

          <h3>21. GOVERNING LAW AND DISPUTE RESOLUTION</h3>
          <p>
            This Policy is governed by and construed in accordance with the laws of Victoria, Australia. Each party irrevocably submits to the non-exclusive jurisdiction of the courts of Victoria and the courts hearing appeals from those courts.
          </p>
          <p>
            In the event of a dispute arising under or in connection with this Policy, the parties agree to first attempt to resolve the dispute through good faith negotiations for a period of not less than 14 days following written notice of the dispute by one party to the other.
          </p>
          <p>
            If the dispute is not resolved through negotiation, either party may refer the dispute to mediation before a mediator agreed by the parties or, failing agreement within 5 business days, appointed by the Australian Disputes Centre in accordance with its mediation guidelines.
          </p>
          <p>
            Nothing in this clause prevents either party from seeking urgent interlocutory or injunctive relief from a court of competent jurisdiction.
          </p>

          <h3>22. ACKNOWLEDGEMENT</h3>
          <p>By accessing or using Servicehub, the Provider acknowledges that it has read, understood and agrees to comply with this Acceptable Use Policy.</p>
        </div>
      </div>
    </div>
  );
};

export default AcceptableUsePolicy;
